import { Button, Modal, Progress, Spin } from "antd";
import React, { useEffect, useState } from "react";
import styles from "../../pages/BuildingId/buildingId.module.scss";
import Dropzone from "react-dropzone";
import { useRecoilState } from "recoil";
import CloseIcon from "../../Assets/Icons/CloseIcon";
import UploadIcon from "../../Assets/Icons/UploadIcon";
import { buildingBlockImportImageModal } from "../../atoms";
import { FileObject } from "../../utils/models/File";
import {
  useFloorImageCreate,
  useFloorImageDelete,
  useUploadFile,
} from "../../queries/mutation";
import { BASE_URL } from "../../Service/RequestService";
import { useFloorImageGetBy } from "../../queries/queries";
import TrushSqareIcon from "../../Assets/Icons/TrushSqareIcon";
import RefreshIcon from "../../Assets/Icons/RefreshIcon";

const BuildingBlockUploadImage = () => {
  const [uploadImageModal, setUploadImageModal] = useRecoilState(
    buildingBlockImportImageModal
  );
  const { data, isLoading, isFetching } = useFloorImageGetBy(
    uploadImageModal.buildingId
  );
  const floorImageCreate = useFloorImageCreate(uploadImageModal.buildingId);
  const floorImageDelete = useFloorImageDelete(uploadImageModal.buildingId);
  const [absolutePath, setAbsolutePath] = useState("");
  const uploadFile = useUploadFile(getFile);

  const handleClose = () => {
    setUploadImageModal({
      visible: false,
      floor: 0,
      name: "",
      type: "",
      buildingId: 0,
    });
    setAbsolutePath("");
  };

  const handleDrop = (acceptedFiles: any) => {
    const formData = new FormData();
    formData.append("files", acceptedFiles[0]);
    uploadFile.mutate(formData);
  };

  function getFile(file: FileObject[]) {
    setAbsolutePath(file[0].absolutePath);
    floorImageCreate.mutate({
      buildingId: uploadImageModal.buildingId,
      imageId: file[0].id,
      id: data ? data.floorImageId : 0,
    });
  }

  useEffect(() => {
    if (data) {
      setAbsolutePath(data?.imagePath);
    }
  }, [data]);

  const handleDelete = () => {
    console.log("delte");
    if (data?.floorImageId) {
      floorImageDelete?.mutate(data?.floorImageId);
    }
  };

  return (
    <Modal
      title={
        <>
          {uploadImageModal.name}{" "}
          <span onClick={handleClose}>
            <CloseIcon />
          </span>
        </>
      }
      visible={uploadImageModal.visible}
      onCancel={handleClose}
      footer={false}
      closable={false}
      wrapClassName="building_block_svg_modal"
      width={650}
    >
      <Spin spinning={uploadFile.isLoading || isFetching || isLoading}>
        {data ? (
          <div className="building_block_svg_modal_imageCustomUpload">
            <img
              src={BASE_URL + absolutePath}
              alt=""
              style={{ width: "100%" }}
            />
            <div>
              <Button className="customMiniButton">
                <label
                  htmlFor={"file" + uploadImageModal.buildingId}
                  style={{ width: "100%" }}
                >
                  <RefreshIcon />
                </label>
                <input
                  type="file"
                  id={"file" + uploadImageModal.buildingId}
                  pattern="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => {
                    handleDrop(e.target.files);
                  }}
                />
              </Button>
              <Button className="customMiniButton" onClick={handleDelete}>
                <TrushSqareIcon />
              </Button>
            </div>
          </div>
        ) : (
          <Dropzone
            onDrop={handleDrop}
            accept={{
              "image/*": [".jpeg", ".png", ".PNG"],
            }}
            minSize={1024}
            maxSize={30720000}
            multiple={false}
          >
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject,
            }) => {
              const additionalClass = isDragAccept
                ? styles.buildingId_fullImageUpload_accept
                : isDragReject
                ? styles.buildingId_fullImageUpload_reject
                : "";

              return (
                <div
                  style={{
                    width: "100%",
                    marginBottom: 32,
                    background: "#ffffff",
                  }}
                  {...getRootProps({
                    className: `${styles.buildingId_fullImageUpload} ${additionalClass}`,
                  })}
                >
                  <input {...getInputProps()} />
                  <UploadIcon />
                  <h1>
                    Fayli oling va shuyerga tashlang yoki<span>Tanlang</span>
                  </h1>
                  <p>Fayl formatlari: JPEG, JPG</p>
                </div>
              );
            }}
          </Dropzone>
        )}
      </Spin>
      {/* <div className="building_block_svg_modal_imageProgress">
        <span>
          <DocumentTextIcon />
        </span>
        <div>
          <p>
            File_Name.zip <span>52%</span>
          </p>
          <Progress percent={50} status="active" showInfo={false} />
        </div>
        <b>
          <CloseIconBorderIcon />
        </b>
      </div> */}
      <div
        className="building_block_svg_modal_footer"
        style={{ justifyContent: "center" }}
      >
        <Button onClick={handleClose}>Cancel</Button>
        <Button>Save</Button>
      </div>
    </Modal>
  );
};

export default BuildingBlockUploadImage;
